import { styled } from "@mui/system";
export const ColorFieldContainer = styled("div") `
    display: flex;
`;
export const ColorFieldPreview = styled("div") `
    width: 20px;
    height: 20px;
    margin-right: 5px;
`;
